import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { convertDetailsTableData } from '../utils';

import { getSurchargesMaintenanceDetailsById } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

const useGetSurchargesMaintenanceDetail = (rowId?: number | null) => {
  const { t } = useTranslation();
  const { data, isFetching, refetch } = useQuery({
    queryKey: ['surcharges-dyn', 'get', rowId],
    queryFn: async () => {
      const { data } = await getSurchargesMaintenanceDetailsById(rowId);
      return convertDetailsTableData(data);
    },
    enabled: !!rowId,
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('fetchError')
      });
    }
  });

  return { isFetching, data, refetch };
};

export default useGetSurchargesMaintenanceDetail;
